





































import TableCell from './TableCell.vue'
import OrderRoutePickup from '@/components/order-common/OrderRoutePickup.vue'
import OrderRouteDropoff from '@/components/order-common/OrderRouteDropoff.vue'

export default {
  components: {
    TableCell,
    OrderRoutePickup,
    OrderRouteDropoff
  },
  props: {
    multiStop: { type: Object, required: true },
    pickupStart: { type: String, default: null },
    pickupEnd: { type: String, default: null },
    deliveryStart: { type: String, default: null },
    deliveryEnd: { type: String, default: null }
  }
}
